const getAverage = (values: any) => {
  if (!values) return 0;

  // if value already number
  if (typeof values === "number") return values;

  const nums = Object.values(values).filter(
    (v) => typeof v === "number"
  );

  if (!nums.length) return 0;

  const total = nums.reduce((p: number, n: any) => p + n, 0);

  return total / nums.length;
};

export default getAverage;
